import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: ${pxToRem(16)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.1);
  max-width: 60%;
  min-width: ${pxToRem(500)};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${pxToRem(20)} ${pxToRem(30)};

  h2 {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 700;
    margin: 0;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: ${pxToRem(1)};
  background-color: rgb(225, 224, 229);
`;

export const GroupName = styled.div`
  padding: ${pxToRem(16)} ${pxToRem(30)};
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 600;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  font-size: ${pxToRem(24)};
  color: #ccc;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #000;
  }
`;

export const ModalBody = styled.div`
  padding: ${pxToRem(30)};
  padding-bottom: 0;
`;

export const ModalFooter = styled.div`
  padding: ${pxToRem(30)};
  padding-top: 0px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const FieldWrapper = styled.div`
  margin-bottom: ${pxToRem(24)};
  width: 100%;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  padding: ${pxToRem(12)} ${pxToRem(16)};
  width: 100%;
  font-size: ${pxToRem(16)};
  border-radius: ${pxToRem(10)};
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  background: rgb(247, 248, 248);
  scrollbar-width: none;

  ${({ hasError }) =>
    hasError &&
    css`
      border: ${pxToRem(1)} solid rgb(242, 40, 98);
      background: rgba(114, 82, 220, 0.15);
    `}

  &:focus {
    border: ${pxToRem(1)} solid rgb(114, 82, 220);
    background: rgba(114, 82, 220, 0.15);
  }
`;

export const ErrorMessage = styled.div`
  font-size: ${pxToRem(12)};
  color: #ff4d4d;
  margin-top: ${pxToRem(-10)};
  margin-bottom: ${pxToRem(5)};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
